import {Routes} from '@app/router/Routes';
import {FC} from 'react';
import {Navigate} from 'react-router-dom';

const HomeRedirect: FC = () => {
  return <Navigate to={Routes.AuditHistory} />;
};

export default HomeRedirect;
